import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../../../_services/category.service';
import { ActivatedRoute, Params } from '@angular/router';
import { LocationService } from '../../../_services/location.service';

@Component({
  selector: 'app-main-navigation',
  templateUrl: './main-navigation.component.html',
  styleUrls: ['./main-navigation.component.scss']
})
export class MainNavigationComponent implements OnInit {

  country: string = '';
  language: string = '';
  link: any;
  IsHidden = true;
  categoriesArray: any = [];
  categoriesChild: any;
  category: any;
  categoryList: any = [];

  selectedCategory: any = {
    id: 1,
    link: 'test'
  };
  loading: boolean;

  constructor(
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private locationService: LocationService
  ) {
    const routeParams = this.route.snapshot.params;
    // console.log(routeParams);
  }

  getCategories(country: string, language: string): void {
    this.categoryService.getCategories(country, language)
      .subscribe(
        resultArray => {
          
          this.categoriesArray = resultArray;
          console.log(this.categoriesArray)
          this.selectedCategory = this.categoriesArray.categories[0].child;

            // removes blank parent categories
            let tmp=[]
            for (let key in this.categoriesArray.categories) {
            //console.log(this.categoriesArray.categories[key].child.length);
              if(this.categoriesArray.categories[key].child.length != 0){
                tmp.push(this.categoriesArray.categories[key]);
              }
           };

           this.categoriesArray.categories = tmp;
           //console.log(this.categoriesArray.categories)
        },

        error => console.log('Error ::' + error)
      );
  }

  setObject(item: any) {
    this.selectedCategory = item;
  }

  onSelect() {
    this.IsHidden = !this.IsHidden;
  }

  ngOnInit(): void {
    //console.log(this.categoriesArray)
    setTimeout(() => {
      this.country = this.locationService.country;
      this.language = this.locationService.langCode;
      console.log(this.country);
      if(this.country == "de" && (this.language == undefined || this.language == "undefined") ) {
        window.location.href = 'http://www.sharphomeappliances.com/de/de';
      } else if(this.country == "eu" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/'+this.country+'/en';
      } else if(this.country == "pl" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/'+this.country+'/pl';
      } else if(this.country == undefined && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/eu/en';
      } else if(this.country == "fr" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/fr/fr';
      } else if(this.country == "it" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/it/it';
      } else if(this.country == "es" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/es/es';
      } else if(this.country == "uk" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/uk/uk';
      } else if(this.country == "se" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/se/sv';
      } else if(this.country == "fi" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/fi/fi';
      } else if(this.country == "si" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/si/sl';
      } else if(this.country == "sk" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/sk/sk';
      } else if(this.country == "ro" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/ro/ro';
      } else if(this.country == "cz" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/cz/cz';
      } else if(this.country == "pt" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/pt/pt';
      } else if(this.country == "no" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/no/no';
      } else if(this.country == "lt" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/lt/lt';
      } else if(this.country == "hu" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/hu/hu';
      } else if(this.country == "nl" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/nl/nl';
      } else if(this.country == "dk" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/dk/da';
      } else if(this.country == "hr" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/hr/hr';
      } else if(this.country == "gr" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/gr/gr';
      } else if(this.country == "ru" && (this.language == undefined || this.language == "undefined")) {
        window.location.href = 'http://www.sharphomeappliances.com/ru/ru';
      } else if(this.language == "undefined" || this.language == undefined ){
        window.location.href = 'http://www.sharphomeappliances.com/'+this.country+'/'+this.country;
      }
      this.getCategories(this.country, this.language);
    }, 1500);
  }
}
